module.exports = __webpack_public_path__ + "img/hb.2d67cab6.png";